module.exports = __webpack_public_path__ + "img/login.bb210399.jpg";